import { Box } from "@mui/material";

import { useShuffledAfterHydration } from "@/src/hooks/useShuffledAfterHydration";
import { type DealerLogoData } from "@/src/utils/dealerLogoUtils";

import DealerLogoCard from "./DealerLogoCard";

interface DealerLogoCardsProps {
  dealerLogos: DealerLogoData;
}

const DealerLogoCards = ({ dealerLogos }: DealerLogoCardsProps) => {
  const orderedLogos = useShuffledAfterHydration(dealerLogos);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        maxWidth: "1200px",
        margin: "0 auto"
      }}
    >
      {orderedLogos.primary.map((logo) => (
        <DealerLogoCard
          key={`logo-primary-${logo.fileName}`}
          category="primary"
          logo={logo}
        />
      ))}
      {orderedLogos.secondary.map((logo) => (
        <DealerLogoCard
          key={`logo-secondary-${logo.fileName}`}
          category="secondary"
          logo={logo}
        />
      ))}
    </Box>
  );
};

export default DealerLogoCards;
